import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Loader from '../Utility/Loader/Loader';
import noImage from '../../assets/images/no-image.png';

function ImageLazyLoader({ src, height, imageRemoved }) {
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      {!loaded && (
        <div className="loader-container">
          <Loader />
        </div>
      )}
      <LazyLoadImage
        alt="poster"
        height={height}
        src={src}
        effect="opacity"
        afterLoad={() => setLoaded(true)}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          if (imageRemoved) {
            currentTarget.src = imageRemoved;
          } else {
            currentTarget.src = noImage;
          }
        }}
      />
    </>
  );
}

export default ImageLazyLoader;
